import { useNavigate } from 'react-router-dom'
import { ChevronRight, Gift } from 'lucide-react'
import { useClaimableRewards } from '@/hooks/useClaimableRewards'

function label(count: number): string {
  return count === 1 ? '1 recompensa' : `${count} recompensas`
}

/**
 * Clickable reward toast, mounted once in GameLayout. Stays while there are
 * unclaimed Metas and deep-links to Carrera → Metas, scrolling to the first
 * claimable goal. The persistent count lives on the Carrera nav item (see
 * useNavBadges); this is the completion nudge.
 */
export function RewardAlert({ isMobile }: { isMobile: boolean }) {
  const { count, firstId } = useClaimableRewards()
  const navigate = useNavigate()
  if (count === 0) return null

  const rewardsRoute = firstId ? `/career?tab=metas&goal=${firstId}` : '/career?tab=metas'

  // Mobile: pin above the music bar + bottom nav. Desktop: float bottom-right.
  const bottom = isMobile
    ? 'calc(var(--bottom-nav-height) + var(--music-bar-height) + var(--safe-area-bottom) + 10px)'
    : '20px'

  return (
    <button
      onClick={() => navigate(rewardsRoute)}
      className="glass-card-static"
      style={{
        position: 'fixed',
        bottom,
        right: isMobile ? 8 : 24,
        left: isMobile ? 8 : 'auto',
        maxWidth: isMobile ? 'none' : 320,
        zIndex: 56,
        display: 'flex',
        alignItems: 'center',
        gap: '0.6rem',
        padding: '0.7rem 0.85rem',
        border: '1px solid var(--gold)',
        cursor: 'pointer',
        color: 'var(--text-primary)',
        textAlign: 'left',
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 30,
          height: 30,
          borderRadius: 8,
          background: 'var(--gold-fill)',
          color: 'var(--gold)',
          flexShrink: 0,
        }}
      >
        <Gift size={17} />
      </span>
      <span style={{ flex: 1, lineHeight: 1.25 }}>
        <span style={{ display: 'block', fontWeight: 700, fontSize: '0.85rem' }}>
          {count === 1 ? 'Recompensa lista' : 'Recompensas listas'}
        </span>
        <span style={{ fontSize: '0.74rem', color: 'var(--text-secondary)' }}>
          Reclama {label(count)} en Carrera
        </span>
      </span>
      <ChevronRight size={18} style={{ color: 'var(--gold)', flexShrink: 0 }} />
    </button>
  )
}
